import CopyFieldIcon from "components/CopyField/Icon";
import FormFieldViewText from "components/FormFields/ViewText";
import Banner from "ds/components/Banner";
import Box from "ds/components/Box";
import DrawerBody from "ds/components/Drawer/Body";
import DrawerHeader from "ds/components/Drawer/Header";
import DrawerHeaderTitle from "ds/components/DrawerNew/HeaderTitle";
import DrawerCloseIcon from "ds/components/DrawerNew/CloseIcon";
import Input from "ds/components/Input";
import { ScimOauthClient } from "types/generated";

type SettingsSingleSignOnScimCredentialsProps = {
  credentials: Pick<
    ScimOauthClient,
    "clientID" | "clientSecret" | "accessTokenEndpoint" | "connnectorBaseURL"
  >;
};

const SettingsSingleSignOnScimCredentials = ({
  credentials,
}: SettingsSingleSignOnScimCredentialsProps) => {
  return (
    <>
      <DrawerHeader justify="between">
        <DrawerHeaderTitle title="Connect SCIM" />
        <DrawerCloseIcon />
      </DrawerHeader>
      <DrawerBody gap="x-large">
        <FormFieldViewText
          label="SCIM connector base URL"
          value={credentials.connnectorBaseURL}
          withCopy
          noMargin
        />
        <FormFieldViewText
          label="Access token endpoint"
          value={credentials.accessTokenEndpoint}
          withCopy
          noMargin
        />
        <FormFieldViewText label="Client ID" value={credentials.clientID} withCopy noMargin />

        <Banner variant="warning" title="Client secret">
          Make sure to copy the client secret as you will not be able to see it again.
          <Box gap="medium" grow="0" fullWidth margin="small 0 0 0">
            <Input value={credentials.clientSecret ?? ""} disabled />
            <CopyFieldIcon
              value={credentials.clientSecret ?? ""}
              title="Copy client secret"
              size="medium"
            />
          </Box>
        </Banner>
      </DrawerBody>
    </>
  );
};

export default SettingsSingleSignOnScimCredentials;
